import React, { useState, useEffect } from 'react';
import { useCRM } from '../../context/CRMContext';
import { canAccessPage as sharedCanAccessPage } from '../../utils/access';
import { logout } from '../../firebase/auth';
import { db } from '../../firebase/config';
import { doc, onSnapshot } from 'firebase/firestore';
import SupportPanel from '../Support/SupportPanel';

const NAV = [
  {
    section: 'MAIN',
    items: [
      { id: 'dashboard', label: 'Dashboard', icon: (
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/>
          <rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/>
        </svg>
      )},
      { id: 'leads', label: 'Leads', icon: (
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
          <circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
        </svg>
      )},
      { id: 'pipeline', label: 'Pipeline', icon: (
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="3" width="5" height="18"/><rect x="10" y="6" width="5" height="15"/>
          <rect x="17" y="9" width="5" height="12"/>
        </svg>
      )},
      { id: 'followups', label: 'Follow-ups', badge: 'overdue', icon: (
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
        </svg>
      )},
    ]
  },
  {
    section: 'COUNSELING',
    items: [
      { id: 'counselinghub', label: 'Counseling Hub', moduleKey: 'counselinghub', icon: (
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 2L2 7l10 5 10-5-10-5z"/>
          <path d="M2 17l10 5 10-5"/>
          <path d="M2 12l10 5 10-5"/>
        </svg>
      )},
    ]
  },
  {
    section: 'TEST PREP',
    items: [
      { id: 'testprep', label: 'Test Prep', moduleKey: 'testprep', icon: (
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 20h9"/>
          <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/>
        </svg>
      )},
    ]
  },
  {
    section: 'ADMISSIONS',
    items: [
      { id: 'engagement', label: 'Engagement', icon: (
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
          <circle cx="9" cy="7" r="4"/>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
        </svg>
      )},
      { id: 'meetings', label: 'Meetings', moduleKey: 'meetings', icon: (
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
          <line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/>
          <line x1="3" y1="10" x2="21" y2="10"/>
        </svg>
      )},
      { id: 'documents', label: 'Documents', moduleKey: 'documents', icon: (
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
          <polyline points="14 2 14 8 20 8"/>
          <line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/>
        </svg>
      )},
      { id: 'applications', label: 'Applications', moduleKey: 'applications', icon: (
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 10v6M2 10l10-5 10 5-10 5z"/>
          <path d="M6 12v5c3 3 9 3 12 0v-5"/>
        </svg>
      )},
      { id: 'universities', label: 'Universities', moduleKey: 'universities', icon: (
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
          <polyline points="9 22 9 12 15 12 15 22"/>
        </svg>
      )},
      { id: 'subagents', label: 'Sub-Agents', moduleKey: 'subAgents', icon: (
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
          <circle cx="9" cy="7" r="4"/>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
        </svg>
      )},
    ]
  },
  {
    section: 'ENGAGEMENT',
    items: [
      { id: 'automations', label: 'Automations', adminOnly: true, icon: (
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
        </svg>
      )},
      { id: 'campaigns', label: 'Campaigns', featureKey: 'campaigns', icon: (
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polygon points="22 2 15 22 11 13 2 9 22 2"/>
        </svg>
      )},
      { id: 'webforms', label: 'Web Forms', featureKey: 'webForms', icon: (
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="3" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/>
          <line x1="9" y1="21" x2="9" y2="9"/>
        </svg>
      )},
      { id: 'integrations', label: 'Integrations', featureKey: 'integrations', adminOnly: true, icon: (
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/>
          <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>
        </svg>
      )},
      { id: 'assessments', label: 'Assessments', moduleKey: 'assessments', featureKey: 'assessments', icon: (
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>
        </svg>
      )},
      { id: 'reports', label: 'Reports', moduleKey: 'reports', icon: (
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/>
          <line x1="6" y1="20" x2="6" y2="14"/><line x1="2" y1="20" x2="22" y2="20"/>
        </svg>
      )},
      { id: 'digitalmedia', label: 'Digital Media', moduleKey: 'digitalmedia', icon: (
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="2"/>
          <path d="M16.24 7.76a6 6 0 0 1 0 8.49M7.76 16.24a6 6 0 0 1 0-8.49M19.07 4.93a10 10 0 0 1 0 14.14M4.93 19.07a10 10 0 0 1 0-14.14"/>
        </svg>
      )},
    ]
  },
  {
    section: 'ADMIN',
    items: [
      { id: 'leaves', label: 'Leave Manager', moduleKey: 'leaves', icon: (
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
          <line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/>
          <line x1="3" y1="10" x2="21" y2="10"/>
          <path d="M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01"/>
        </svg>
      )},
      { id: 'workreport', label: 'Work Report', moduleKey: 'workreport', icon: (
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 3v18h18"/>
          <path d="M18.7 8l-5.1 5.2-3-3L7 14"/>
        </svg>
      )},
      { id: 'wamonitor', label: 'WA Monitor', moduleKey: 'wamonitor', adminOnly: true, icon: (
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
        </svg>
      )},
      { id: 'activitylog', label: 'Activity Log', adminOrVisible: true, featureKey: 'activityLog', icon: (
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
          <polyline points="14 2 14 8 20 8"/>
          <line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/>
          <polyline points="10 9 9 9 8 9"/>
        </svg>
      )},
      { id: 'settings', label: 'Settings', icon: (
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="3"/>
          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
        </svg>
      )},
    ]
  }
];


export default function Sidebar() {
  const { currentPage, setCurrentPage, followups, leads, currentUser, rrSettings, company, companyFeatures } = useCRM();
  const [collapsed,     setCollapsed]     = useState(false);
  const [showSupport,   setShowSupport]   = useState(false);
  const [supportUnread, setSupportUnread] = useState(0);

  // Subscribe to this company's support thread to show unread badge
  useEffect(() => {
    if (!currentUser?.companyId || currentUser?.role !== 'admin') return;
    return onSnapshot(doc(db, 'supportThreads', currentUser.companyId), snap => {
      setSupportUnread(snap.exists() ? (snap.data().unreadAdmin || 0) : 0);
    });
  }, [currentUser?.companyId, currentUser?.role]);

  const overdueCount = followups.filter(f => f.status === 'overdue').length;
  // currentUser.leads is a denormalized counter that's only ever set to 0 at
  // creation time and never updated — count live from the leads collection
  // instead so "My Leads" reflects reality.
  const myLeadsCount = (leads || []).filter(l => l.assignedToId === currentUser?.id).length;
  const logVisibility = rrSettings?.logVisibility || [];
  const canSeeActivityLog = currentUser?.role === 'admin'
    || currentUser?.role === 'superadmin'
    || logVisibility.includes(currentUser?.id);
  // ── Access control helper (shared with App.js — see utils/access.js) ──────
  const canAccessPage = (pageId) => sharedCanAccessPage(currentUser, company, pageId);

  const appName  = company?.theme?.appName || 'Clarion';
  const logoUrl  = company?.logoUrl || '';
  const initials = appName.slice(0, 1).toUpperCase();

  const safeUser = currentUser || { name: 'User', role: 'admin', avatar: { bg: '#7c3aed', color: '#fff' } };
  const avatarInitials = (safeUser.name || 'U').split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase();

  return (
    <aside style={{
      width: collapsed ? 68 : 232,
      background: 'var(--bg-primary)',
      borderRight: '1px solid var(--border)',
      display: 'flex',
      flexDirection: 'column',
      transition: 'width 0.25s ease',
      flexShrink: 0,
      position: 'relative',
      zIndex: 10,
    }}>
      {/* Logo / Brand */}
      <div style={{
        padding: collapsed ? '20px 14px' : '20px 20px',
        borderBottom: '1px solid rgba(0,0,0,0.05)',
        display: 'flex', alignItems: 'center', gap: 10,
      }}>
        {logoUrl ? (
          <img src={logoUrl} alt={appName} style={{ width: 34, height: 34, borderRadius: 9, objectFit: 'contain', flexShrink: 0 }} />
        ) : (
          <div style={{
            width: 34, height: 34, borderRadius: 9, flexShrink: 0,
            background: 'var(--grad-logo)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 15, fontWeight: 800, color: '#fff',
            boxShadow: '0 4px 16px var(--color-primary-glow)',
          }}>{initials}</div>
        )}
        {!collapsed && (
          <div>
            <div style={{ fontSize: 15, fontWeight: 700, color: '#0f172a', letterSpacing: '-0.3px' }}>{appName}</div>
            <div style={{ fontSize: 10, color: '#475569', fontWeight: 500 }}>PRO</div>
          </div>
        )}
      </div>

      {/* Nav */}
      <nav style={{ flex: 1, padding: '12px 10px', overflowY: 'auto', overflowX: 'hidden' }}>
        {NAV.map(group => (
          <div key={group.section} style={{ marginBottom: 20 }}>
            {!collapsed && (
              <div style={{ fontSize: 10, fontWeight: 600, letterSpacing: '1px', color: '#94a3b8', padding: '0 6px', marginBottom: 6 }}>
                {group.section}
              </div>
            )}
            {group.items.filter(item => {
              // Module-level gate: super admin decides which modules each company gets.
              // Items with a moduleKey are hidden unless that key is in company.enabledModules.
              // If enabledModules is not set yet (old company docs) we treat it as "all enabled"
              // so existing companies aren't broken on deploy.
              if (item.moduleKey) {
                const em = company?.enabledModules;
                if (Array.isArray(em) && !em.includes(item.moduleKey)) return false;
              }
              if (item.featureKey && companyFeatures && companyFeatures[item.featureKey] === false) return false;
              if (item.adminOrVisible) return canSeeActivityLog;
              if (item.adminOnly) return currentUser?.role === 'admin' || currentUser?.role === 'superadmin';
              if (!canAccessPage(item.id)) return false;
              return true;
            }).map(item => {
              const isActive   = currentPage === item.id;
              const badgeCount = item.badge === 'overdue' ? overdueCount : null;
              return (
                <div
                  key={item.id}
                  className={'nav-item' + (isActive ? ' active' : '')}
                  onClick={() => setCurrentPage(item.id)}
                  style={{ justifyContent: collapsed ? 'center' : 'flex-start', padding: collapsed ? '10px' : '9px 13px', position: 'relative' }}
                  title={collapsed ? item.label : ''}
                >
                  <span style={{ color: isActive ? 'var(--color-primary-text)' : '#64748b', flexShrink: 0 }}>{item.icon}</span>
                  {!collapsed && (
                    <>
                      <span style={{ flex: 1 }}>{item.label}</span>
                      {badgeCount > 0 && (
                        <span style={{ background: '#ef4444', color: '#fff', borderRadius: 10, fontSize: 10, fontWeight: 700, padding: '1px 6px', minWidth: 18, textAlign: 'center' }}>
                          {badgeCount}
                        </span>
                      )}
                    </>
                  )}
                  {collapsed && badgeCount > 0 && (
                    <span style={{ position: 'absolute', top: 4, right: 4, width: 8, height: 8, borderRadius: '50%', background: '#ef4444' }} />
                  )}
                </div>
              );
            })}
          </div>
        ))}

      </nav>

      {/* Quick Stats */}
      {!collapsed && (
        <div style={{
          margin: '0 10px 8px',
          padding: '10px 12px',
          borderRadius: 10,
          background: 'linear-gradient(135deg, var(--color-primary-soft) 0%, rgba(59,130,246,0.08) 100%)',
          border: '1px solid var(--color-primary-light)',
        }}>
          <div style={{ fontSize: 10, color: '#475569', fontWeight: 600, letterSpacing: '0.5px', marginBottom: 6 }}>QUICK STATS</div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 16, fontWeight: 800, color: 'var(--color-primary)' }}>{myLeadsCount}</div>
              <div style={{ fontSize: 9, color: '#64748b' }}>My Leads</div>
            </div>
            <div style={{ width: 1, background: 'rgba(0,0,0,0.06)' }} />
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 16, fontWeight: 800, color: overdueCount > 0 ? '#ef4444' : '#10b981' }}>{overdueCount}</div>
              <div style={{ fontSize: 9, color: '#64748b' }}>Overdue</div>
            </div>
            <div style={{ width: 1, background: 'rgba(0,0,0,0.06)' }} />
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 16, fontWeight: 800, color: '#3b82f6' }}>{followups.filter(f => f.status === 'pending').length}</div>
              <div style={{ fontSize: 9, color: '#64748b' }}>Pending</div>
            </div>
          </div>
        </div>
      )}

      {/* Support button — admin only */}
      {currentUser?.role === 'admin' && (
        <button
          onClick={() => setShowSupport(true)}
          title="Help & Support"
          style={{
            margin: '0 10px 8px',
            padding: collapsed ? '9px' : '9px 14px',
            borderRadius: 10,
            border: supportUnread > 0 ? '1px solid rgba(245,158,11,0.4)' : '1px solid rgba(0,0,0,0.06)',
            background: supportUnread > 0 ? 'rgba(245,158,11,0.08)' : 'rgba(0,0,0,0.03)',
            cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: collapsed ? 'center' : 'flex-start',
            gap: 8, width: 'calc(100% - 20px)',
            transition: 'all 0.15s',
          }}
          onMouseEnter={e => { e.currentTarget.style.background = 'rgba(245,158,11,0.1)'; e.currentTarget.style.borderColor = 'rgba(245,158,11,0.35)'; }}
          onMouseLeave={e => { e.currentTarget.style.background = supportUnread > 0 ? 'rgba(245,158,11,0.08)' : 'rgba(0,0,0,0.03)'; e.currentTarget.style.borderColor = supportUnread > 0 ? 'rgba(245,158,11,0.4)' : 'rgba(0,0,0,0.06)'; }}
        >
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={supportUnread > 0 ? '#f59e0b' : '#64748b'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
            <line x1="9" y1="10" x2="15" y2="10"/>
            <line x1="9" y1="14" x2="12" y2="14"/>
          </svg>
          {!collapsed && (
            <>
              <span style={{ flex: 1, fontSize: 12, fontWeight: 600, color: supportUnread > 0 ? '#f59e0b' : '#64748b', textAlign: 'left' }}>
                Help & Support
              </span>
              {supportUnread > 0 && (
                <span style={{ background: '#f59e0b', color: '#fff', borderRadius: 10, fontSize: 10, fontWeight: 700, padding: '1px 6px', minWidth: 18, textAlign: 'center' }}>
                  {supportUnread}
                </span>
              )}
            </>
          )}
          {collapsed && supportUnread > 0 && (
            <span style={{ position: 'absolute', top: 4, right: 4, width: 8, height: 8, borderRadius: '50%', background: '#f59e0b' }} />
          )}
        </button>
      )}

      {/* Support Panel (slide-in drawer) */}
      {showSupport && currentUser?.companyId && (
        <SupportPanel
          companyId={currentUser.companyId}
          companyName={company?.name || currentUser.companyId}
          currentUser={currentUser}
          onClose={() => setShowSupport(false)}
        />
      )}

      {/* User info + Sign Out */}
      <div style={{
        margin: '0 10px 10px',
        padding: '10px 12px',
        borderRadius: 10,
        background: 'rgba(0,0,0,0.02)',
        border: '1px solid rgba(0,0,0,0.05)',
        display: 'flex',
        alignItems: 'center',
        gap: 10,
      }}>
        <div className="avatar" style={{
          background: safeUser.avatar?.bg || '#7c3aed',
          color: safeUser.avatar?.color || '#fff',
          width: 30, height: 30, fontSize: 11, flexShrink: 0,
        }}>
          {avatarInitials}
        </div>
        {!collapsed && (
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 12, fontWeight: 600, color: '#0f172a', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {safeUser.name}
            </div>
            <div style={{ fontSize: 10, color: '#475569', textTransform: 'capitalize' }}>
              {safeUser.role === 'superadmin' ? 'Admin' : safeUser.role}
            </div>
          </div>
        )}
        <button
          onClick={() => logout()}
          title="Sign out"
          style={{
            background: 'none', border: 'none', cursor: 'pointer',
            color: '#94a3b8', padding: '4px', borderRadius: 6,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            flexShrink: 0, transition: 'color 0.15s',
          }}
          onMouseEnter={e => e.currentTarget.style.color = '#ef4444'}
          onMouseLeave={e => e.currentTarget.style.color = '#94a3b8'}
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
            <polyline points="16 17 21 12 16 7"/>
            <line x1="21" y1="12" x2="9" y2="12"/>
          </svg>
        </button>
      </div>

      {/* Collapse toggle */}
      <div
        onClick={() => setCollapsed(c => !c)}
        style={{
          margin: '0 10px 14px', padding: '8px', borderRadius: 8,
          cursor: 'pointer', display: 'flex', alignItems: 'center',
          justifyContent: 'center', color: '#94a3b8',
          fontSize: 11, fontWeight: 500, gap: 6,
          background: 'rgba(0,0,0,0.03)', transition: 'all 0.15s',
        }}
        title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          {collapsed
            ? <polyline points="9 18 15 12 9 6" />
            : <polyline points="15 18 9 12 15 6" />}
        </svg>
        {!collapsed && (collapsed ? 'Expand' : 'Collapse')}
      </div>
    </aside>
  );
}
